// The floor's clock, in Europe/London: which day and half-day it is, and the
// minute for the now line. Fixture mode stops the clock at the snapshot's moment.
import { useEffect, useState } from "react";
import type { Day, Half } from "./types";
import { FIXTURE_NOW, fixtureMode } from "../api/mode";

export interface Now { day: Day; half: Half; minute: number }

/** Lunch (12:30–13:00) counts as the afternoon coming up. */
export const halfAt = (minute: number): Half => (minute < 12 * 60 + 30 ? "AM" : "PM");

export function londonNow(date = new Date()): Now {
  if (fixtureMode()) return { day: FIXTURE_NOW.day, minute: FIXTURE_NOW.minute, half: halfAt(FIXTURE_NOW.minute) };
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .formatToParts(date).reduce<Record<string, string>>((o, p) => ((o[p.type] = p.value), o), {});
  const minute = Number(parts.hour) * 60 + Number(parts.minute);
  return { day: `${parts.year}-${parts.month}-${parts.day}`, minute, half: halfAt(minute) };
}

/** Re-renders every 30 s so the now line moves. */
export function useNow(): Now {
  const [now, set] = useState(londonNow);
  useEffect(() => {
    const t = setInterval(() => set(londonNow()), 30_000);
    return () => clearInterval(t);
  }, []);
  return now;
}
